import script from "./EnbekDocumentPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./EnbekDocumentPanel.vue?vue&type=script&lang=ts&setup=true"

import "./EnbekDocumentPanel.vue?vue&type=style&index=0&id=10dd1492&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10dd1492"]])

export default __exports__